/* FABEL — quick-add.js : loads the product form into a drawer from a card. */
(function () {
  'use strict';
  const FABEL = window.FABEL;

  class QuickAdd extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.dataset.variantId) {
          this.addSingleVariant();
        } else {
          this.open();
        }
      });
    }

    /* Products with exactly one variant skip the option drawer entirely. */
    addSingleVariant() {
      const formData = new FormData();
      formData.append('id', this.dataset.variantId);
      formData.append('quantity', '1');
      this.button.setAttribute('data-loading', 'true');
      this.button.disabled = true;

      FABEL.cart.add(formData).then((result) => {
        this.button.removeAttribute('data-loading');
        this.button.disabled = false;
        if (result.error) {
          FABEL.announce(result.error);
          this.open();
          return;
        }
        FABEL.announce(FABEL.strings.itemAdded);
        if (FABEL.settings.cartType === 'drawer') FABEL.cart.open(this.button);
        else window.location.href = FABEL.routes.cart_url;
      });
    }

    open() {
      const drawer = document.getElementById('quick-add-drawer');
      if (!drawer) return;
      const body = drawer.querySelector('[data-quick-add-body]');
      const url = this.dataset.url;

      drawer.open(this.button);
      body.innerHTML = `<p class="quick-add__loading">${FABEL.strings.loading}</p>`;

      fetch(`${url}${url.indexOf('?') > -1 ? '&' : '?'}section_id=quick-add`)
        .then((response) => response.text())
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const content = parsed.querySelector('[data-quick-add-content]');
          body.innerHTML = content ? content.innerHTML : '';
          const first = body.querySelector(FABEL.FOCUSABLE);
          if (first) first.focus({ preventScroll: true });
        })
        .catch(() => {
          body.innerHTML = `<p class="quick-add__loading">${FABEL.strings.cartError}</p>`;
        });
    }
  }
  if (!customElements.get('quick-add')) customElements.define('quick-add', QuickAdd);

  /* When an item is added from the quick add drawer, swap to the cart drawer. */
  FABEL.subscribe('cart:updated', () => {
    const quick = document.getElementById('quick-add-drawer');
    if (quick && quick.getAttribute('data-open') === 'true') quick.close();
  });
})();


/* FABEL — matenrij op de productkaart: één klik legt die maat in de tas. */
(function () {
  'use strict';
  const FABEL = window.FABEL;
  if (!FABEL || !FABEL.cart) return;

  document.addEventListener('click', function (event) {
    const knop = event.target.closest('[data-add-variant]');
    if (!knop) return;
    event.preventDefault();
    event.stopPropagation();
    if (knop.disabled) return;

    const data = new FormData();
    data.append('id', knop.dataset.addVariant);
    data.append('quantity', '1');
    knop.setAttribute('data-loading', 'true');
    knop.disabled = true;

    FABEL.cart.add(data).then(function (resultaat) {
      knop.removeAttribute('data-loading');
      knop.disabled = false;
      if (resultaat && resultaat.error) {
        FABEL.announce(resultaat.error);
        return;
      }
      FABEL.announce(FABEL.strings.itemAdded);
      if (FABEL.settings.cartType === 'drawer') FABEL.cart.open(knop);
      else window.location.href = FABEL.routes.cart_url;
    });
  });
})();
